import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footer-container" };
const _hoisted_2 = { class: "footer-info" };
import { ref, onMounted } from "vue";
import post from "./FooterEdit.vue";
import { getBasicInfo } from "@/api/basic";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Footer',
    setup(__props) {
        const postRef = ref();
        const clickCount = ref(0);
        const basicData = ref({});
        const refreshData = async () => {
            try {
                const res = await getBasicInfo();
                basicData.value = res.data;
            }
            catch {
                // 暂无数据
            }
        };
        onMounted(() => {
            refreshData();
        });
        const onSaved = (data) => {
            basicData.value = data;
        };
        const handleEdit = () => {
            const token = localStorage.getItem("token");
            if (!token) {
                return;
            }
            clickCount.value++;
            if (clickCount.value >= 2) {
                postRef.value.show(basicData.value);
                clickCount.value = 0;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("footer", {
                class: "footer",
                onClick: handleEdit
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("p", null, [
                            _cache[0] || (_cache[0] = _createTextVNode(" Copyright © 2019-2026 广州布由自主科技有限公司 ", -1)),
                            _cache[1] || (_cache[1] = _createElementVNode("a", {
                                class: "footer-link",
                                target: "_blank",
                                href: "https://beian.miit.gov.cn/"
                            }, "粤ICP备19107063号", -1)),
                            _createTextVNode(" | 商务合作：" + _toDisplayString(basicData.value.businessPhone || '-') + " 客服热线：" + _toDisplayString(basicData.value.servicePhone || '-'), 1)
                        ]),
                        _createElementVNode("p", null, "地址：" + _toDisplayString(basicData.value.address || '-'), 1)
                    ])
                ]),
                _createVNode(post, {
                    ref_key: "postRef",
                    ref: postRef,
                    onSaved: onSaved
                }, null, 512)
            ]));
        };
    }
});
